import React, { useState } from 'react';
// Api
import client from '../../api/client';
// Constants
import { SUBMIT_CONTACT_FORM_API } from '../../utils/ApiRoutes';
// Utils
import LoadingSpinner from '../utils/LoadingSpinner';

const emptyFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  location: '',
  availability1: '',
  availability2: '',
  availability3: '',
  experienceDescription: '',
  interests: '',
  referral: '',
  appointmentType: '',
  deposit: '',
  sessionLength: '',
};
function ApplicationForm() {
  const [formData, setFormData] = useState(emptyFormData);

  const [submitted, setSubmitted] = useState(false);
  const submitStates = ['waiting', 'inprogress', 'failed', 'success'];
  const [submitState, setSubmitState] = useState(submitStates[0]); // Default to "waiting"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitState(submitStates[1]); // "inprogress"

    client
      .post(SUBMIT_CONTACT_FORM_API, formData, false)
      .then((res) => {
        setSubmitState(submitStates[3]); // "success"
        setFormData(emptyFormData);
      })
      .catch((err) => {
        console.error('Unable to submit contact request', err);
        setSubmitState(submitStates[2]); // "failed"
      });
  };

  return (
    <section className='grid lg:container lg:mx-auto px-4 sm:px-8 md:px-12'>
      <form
        onSubmit={handleSubmit}
        className='grid gap-4 bg-colour5 shadow-cardShadowBold py-6 md:py-8'
      >
        <section className='grid mx-auto lg:py-8 px-4'>
          <h4 className='text-5xl text-center mb-4 font-medium font-titleFont lg:underline underline-offset-8 decoration-from-font bg-colour2 rounded px-4 py-1 shadow-cardShadowBold shadow-colour4/60 lg:px-12 lg:py-2'>
            Submissive Application V1.1
          </h4>
          <h5 className='mx-auto lg:text-xl uppercase'>
            There Might Be A Test!
          </h5>
        </section>

        <section className='grid px-3 sm:px-4 md:px-8 lg:px-16 lg:pb-6'>
          <div className='grid px-3 py-3 lg:py-8 lg:px-10 bg-colour6 shadow-cardShadow gap-4'>
            {/* Basic Info */}
            {['firstName', 'lastName', 'email', 'phone', 'location'].map(
              (field) => (
                <div key={field}>
                  <label className='font-medium capitalize' htmlFor={field}>
                    {field.replace(/([A-Z])/g, ' $1')}:
                  </label>
                  <input
                    type='text'
                    id={field}
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    placeholder={`Enter your ${field
                      .replace(/([A-Z])/g, ' $1')
                      .toLowerCase()}`}
                    className='w-full border p-2 text-colour3 rounded shadow-md'
                    required
                  />
                </div>
              )
            )}

            {/* Availability */}
            <section>
              <div>
                <h4 className='text-lg'>
                  3 Dates and times you are available for appointments
                </h4>
              </div>
              {[1, 2, 3].map((n) => (
                <div key={n}>
                  <label className='font-medium'>
                    Date & Time Availability {n}:
                  </label>
                  <input
                    type='text'
                    name={`availability${n}`}
                    value={formData[`availability${n}`]}
                    onChange={handleChange}
                    placeholder='e.g., Monday 2pm - 5pm'
                    className='w-full border rounded shadow-md p-2 text-colour3'
                    required
                  />
                </div>
              ))}
            </section>

            {/* Experience Description */}
            <div>
              <label className='font-medium'>
                Describe your experience level:
              </label>
              <textarea
                name='experienceDescription'
                value={formData.experienceDescription}
                onChange={handleChange}
                placeholder='Tell me about your BDSM experience so far'
                className='w-full border rounded shadow-md p-2 text-colour3'
                rows={3}
                required
              />
            </div>

            {/* Interests */}
            <div>
              <label className='font-medium'>
                BDSM activities that interest you:
              </label>
              <textarea
                name='interests'
                value={formData.interests}
                onChange={handleChange}
                placeholder='List specific kinks or scenes that excite you'
                className='w-full border rounded shadow-md p-2 text-colour3'
                rows={3}
                required
              />
            </div>

            {/* Referral */}
            <div>
              <label className='font-medium'>How did you find me?</label>
              <input
                type='text'
                name='referral'
                value={formData.referral}
                onChange={handleChange}
                placeholder='Instagram, Fetlife, Google, Friend, etc.'
                className='w-full border rounded shadow-md p-2 text-colour3'
                required
              />
            </div>

            {/* Appointment Type */}
            <div>
              <label className='font-medium'>
                What kind of appointment would you like to schedule?
              </label>
              <div className='flex gap-4 mt-2 flex-wrap'>
                {['Phone', 'Video', 'In-person'].map((type) => (
                  <label key={type} className='flex items-center'>
                    <input
                      type='radio'
                      name='appointmentType'
                      value={type}
                      className='mr-2 accent-colour2'
                      onChange={handleChange}
                      required
                    />
                    {type.charAt(0).toUpperCase() + type.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            {/* Deposit Willingness */}
            <div>
              <label className='font-medium'>
                Are you willing to pay a deposit?
              </label>
              <div className='flex gap-4 mt-2 flex-wrap'>
                {['Yes', 'No', 'NA - Online Session Only'].map((option) => (
                  <label key={option} className='flex items-center'>
                    <input
                      type='radio'
                      name='deposit'
                      value={option}
                      className='mr-2 accent-colour2'
                      onChange={handleChange}
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>

            {/* Session Length */}
            <div>
              <label className='font-medium'>
                How long would you like to schedule?
              </label>
              <div className='flex gap-4 mt-2 flex-wrap'>
                {['1hr', '90mins', '2hr', '3hr', 'NA - Online/Phone'].map(
                  (duration) => (
                    <label key={duration} className='flex items-center'>
                      <input
                        type='radio'
                        name='sessionLength'
                        value={duration}
                        className='mr-2 accent-colour2'
                        onChange={handleChange}
                        required
                      />
                      {duration}
                    </label>
                  )
                )}
              </div>
            </div>

            {/* Submit */}
            <div className='grid mt-4 lg:mt-8'>
              <button
                type='submit'
                disabled={submitState === submitStates[1]} // "inprogress"
                aria-label='Submit your form'
                className='w-full bg-colour5 shadow-cardShadow hover:bg-colour4 text-white font-bold py-2 px-4 transition duration-300'
              >
                {submitState === submitStates[1] ? (
                  <div className='flex justify-center h-fit mx-auto'>
                    <LoadingSpinner sm={true} />
                  </div>
                ) : (
                  <span>Submit</span>
                )}
              </button>
            </div>
          </div>
        </section>

        {/* Submission Feedback */}
        {submitState === submitStates[3] && ( // "success"
          <div
            role='alert'
            aria-live='polite'
            className='text-green-500 py-3 text-center bg-colour1'
          >
            Your application has been submitted successfully! Mistress Sammi
            will review it soon.{' '}
          </div>
        )}
        {submitState === submitStates[2] && ( // "failed"
          <div
            role='alert'
            aria-live='assertive'
            className='text-error-red py-3 text-center bg-colour1'
          >
            Unable to submit the form. Please try again.
          </div>
        )}
      </form>
    </section>
  );
}

export default ApplicationForm;
